import { Component, ErrorInfo, ReactNode } from 'react';

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  message: string | null;
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, message: null };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return {
      hasError: true,
      message: error.message || 'Unknown rendering error',
    };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Route rendering error:', error, errorInfo);
  }

  private handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center p-6">
          <div className="card max-w-xl w-full bg-red-50 border-red-200">
            <h2 className="text-xl font-semibold text-red-800">Unexpected application error</h2>
            <p className="text-red-700 mt-2">
              {this.state.message || 'A rendering error occurred while loading this screen.'}
            </p>
            <button type="button" onClick={this.handleReload} className="btn-primary mt-4">
              Reload application
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
